"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEmptyValues = exports.toValueMap = void 0;
/** The user has not entered any input */
const hasValue = (value) => {
    if ([undefined, null, ''].includes(value))
        return false;
    if (typeof value === 'object' && Object.keys(value).length === 0)
        return false;
    return true;
};
const hasNumberValue = (value) => (!Number.isNaN(Number(value)));
exports.toValueMap = {
    string: (x) => hasValue(x) ? x : undefined,
    number: (x) => {
        if (!hasValue(x))
            return undefined;
        if (!hasNumberValue(x))
            return x;
        const v = Number(x);
        return v;
    },
    ['boolean']: (x) => hasValue(x) ? x : undefined,
};
const removeEmptyValues = (obj) => {
    if (!hasValue(obj))
        return undefined;
    if (typeof obj !== 'object')
        return obj;
    const result = Object.entries(obj).reduce((acc, [key, value]) => {
        const filteredValue = (0, exports.removeEmptyValues)(value);
        if (filteredValue === undefined)
            return acc;
        return {
            ...acc,
            [key]: filteredValue,
        };
    }, {});
    if (!hasValue(result))
        return undefined;
    return result;
};
exports.removeEmptyValues = removeEmptyValues;
//# sourceMappingURL=utils.js.map